import React, {
    useState,
    useCallback,
    useRef,
    useEffect,
    useMemo,
    useContext,
} from 'react'
import TableDataContext from "components/Table/context/context";
import { getAsins } from "api/amazon";

// This page has: 
// Has listings (CA & US Checkboxes)
// No listings (CA & US Checkboxes)
// Has restrictions (CA & US Checkboxes)
// No restrictions (CA & US Checkboxes)

// The tricky thing is that we don't have restrictions or listings in the original table... Hmmmmm...
// Get a list of corresponding asins (from amazon_items_restrictions and amazon_listings) and then filter based on that.

// Note: This filter works on AND logic. If I check Restricted US and Not Listed CA, I'll get asin's that are restricted in the US AND not listed in CA. 
// So if I try to check both Restricted US and Not Restricted US, 0 rows will be returned after the filter is applied.

// TODO: DIFFERENTIATE BETWEEN USED AND NEW - Right now we assume everything is New.
// TODO: EVERY TIME I OPEN IT IT'S BLANK - The checkmarks don't stay checked. This is where my inexperience with React & front end coding shows. 
// TODO: RELOADING THE PAGE CAUSES AN ERROR - The restriction columns aren't in the view we see on the 365 page, so trying to load saved filters fails.
// TODO: (Lower Priority) Add a filter that shows any products that are listed on multiple stores (we want to avoid listing the same product on multiple stores going forward)
// Filter on load is the string "11: [object Object]" 
// I get a Network error: Failed to load response data. No data found for resource with given identifier. 
// The problem is that we don't actually have a column called 11 in the database we're using...
// Even if we did, the filter doesn't maintain all its info b/c it gets smushed into a string.

const FilterInputRestrictions = ({ column }: any) => {

    const { filter, setFilter, clearFilter } = useContext(TableDataContext) // filter is unused, which is part of the problem. The filtering system I made doesn't mesh with the current filter system on reload...
    const [filterRestrictedUS, setFilterRestrictedUS] = useState<boolean>(false)
    const [filterRestrictedCA, setFilterRestrictedCA] = useState<boolean>(false)
    const [filterNotRestrictedUS, setFilterNotRestrictedUS] = useState<boolean>(false)
    const [filterNotRestrictedCA, setFilterNotRestrictedCA] = useState<boolean>(false)
    const [filterListedUS, setFilterListedUS] = useState<boolean>(false)
    const [filterListedCA, setFilterListedCA] = useState<boolean>(false)
    const [filterNotListedUS, setFilterNotListedUS] = useState<boolean>(false)
    const [filterNotListedCA, setFilterNotListedCA] = useState<boolean>(false)

    const getAsinsForMarketplace = async (marketplace: number, model: string): Promise<string[]> => { // Calls the API to get info from MySQL
        // Note: I changed the accessor value so that column.id will be the store id.
        return await getAsins(1, marketplace, Number(column.id), model)
    }

    useEffect(() => {
        const applyFilters = async () => {

            type FilterKey = '$in' | '$notIn';
            type FilterClause = { $in: string[] } | { $notIn: string[] };
            const filters: FilterClause[] = [];

            const maybeAddFilter = async (condition: boolean, marketplaceId: number, tableName: string, key: FilterKey) => {
                if (!condition) return;
                const asins = await getAsinsForMarketplace(marketplaceId, tableName)
                if (asins.length) {
                    filters.push({ [key]: asins } as FilterClause)
                }
            }

            await Promise.all([
                maybeAddFilter(filterRestrictedUS, 1, 'amazon_items_restrictions', '$in'),
                maybeAddFilter(filterNotRestrictedUS, 1, 'amazon_items_restrictions', '$notIn'),
                maybeAddFilter(filterRestrictedCA, 2, 'amazon_items_restrictions', '$in'),
                maybeAddFilter(filterNotRestrictedCA, 2, 'amazon_items_restrictions', '$notIn'),
                maybeAddFilter(filterListedUS, 1, 'amazon_listings', '$in'),
                maybeAddFilter(filterNotListedUS, 1, 'amazon_listings', '$notIn'),
                maybeAddFilter(filterListedCA, 2, 'amazon_listings', '$in'),
                maybeAddFilter(filterNotListedCA, 2, 'amazon_listings', '$notIn'),
            ])

            if (!filters.length) {
                clearFilter(column.id)
                return
            }

            setFilter({
                field: column.id,
                data: { $and: filters }
            })
        }

        applyFilters()
    }, [
        filterRestrictedUS, filterRestrictedCA,
        filterNotRestrictedUS, filterNotRestrictedCA,
        filterListedUS, filterListedCA,
        filterNotListedUS, filterNotListedCA
    ])

    return (
        <div>
            <div>Restricted</div>
            <label>US</label>
            <input type="checkbox" checked={filterRestrictedUS} onChange={() => setFilterRestrictedUS(!filterRestrictedUS)} />
            <label>CA</label>
            <input type="checkbox" checked={filterRestrictedCA} onChange={() => setFilterRestrictedCA(!filterRestrictedCA)} />
            <div>Not Restricted</div>
            <label>US</label>
            <input type="checkbox" checked={filterNotRestrictedUS} onChange={() => setFilterNotRestrictedUS(!filterNotRestrictedUS)} />
            <label>CA</label>
            <input type="checkbox" checked={filterNotRestrictedCA} onChange={() => setFilterNotRestrictedCA(!filterNotRestrictedCA)} />

            <div>Listed</div>
            <label>US</label>
            <input type="checkbox" checked={filterListedUS} onChange={() => setFilterListedUS(!filterListedUS)} />
            <label>CA</label>
            <input type="checkbox" checked={filterListedCA} onChange={() => setFilterListedCA(!filterListedCA)} />
            <div>Not Listed</div>
            <label>US</label>
            <input type="checkbox" checked={filterNotListedUS} onChange={() => setFilterNotListedUS(!filterNotListedUS)} />
            <label>CA</label>
            <input type="checkbox" checked={filterNotListedCA} onChange={() => setFilterNotListedCA(!filterNotListedCA)} />
        </div>
    )

}

export default FilterInputRestrictions
